import { Popconfirm, PopconfirmProps } from "antd";
import cn from "classnames";
import colorVariables from "variables.module.scss";

import { AlertCircleIcon } from "../../assets/icons/AlertCircle";
import styleAntButtons from "../AntButton/AntButton.module.scss";
import style from "./AntPopConfirm.module.scss";

const AntPopConfirm = (props: PopconfirmProps) => {
  const { overlayClassName, okButtonProps } = props;

  const newButtonProps = {
    ...okButtonProps,
    ...{
      className: cn(styleAntButtons.modalBtn, styleAntButtons.typeUpper),
    },
  };

  return (
    <Popconfirm
      {...props}
      overlayClassName={cn(style.popConfirm, overlayClassName)}
      icon={<AlertCircleIcon color={colorVariables.yellowColor} />}
      okButtonProps={newButtonProps}
      cancelButtonProps={{
        className: cn(styleAntButtons.modalBtn, styleAntButtons.typeUpper),
      }}
    >
      {props.children}
    </Popconfirm>
  );
};

export default AntPopConfirm;
